// extracted by css-extract-rspack-plugin
export default {"container":"container-2QrPh","checkbox":"checkbox-uIGJn","labelText":"labelText-1mGET","withDescription":"withDescription-1Q3yK","description":"description-2f9iy"};